import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v38.1.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
var HistoryMoment = /*#__PURE__*/function () {
  function HistoryMoment(t, s) {
    _classCallCheck(this, HistoryMoment);

    this.forward = t, this.reverse = s;
  }

  _createClass(HistoryMoment, [{
    key: "fuse",
    value: function fuse(t) {
      var s = this.forward,
          r = this.reverse,
          _ref = [t.forward.bind(t), t.reverse.bind(t)],
          e = _ref[0],
          o = _ref[1];
      return this.forward = function () {
        s(), e();
      }, this.reverse = function () {
        r(), o();
      }, this;
    }
  }], [{
    key: "is",
    value: function is(t) {
      return t instanceof HistoryMoment;
    }
  }]);

  return HistoryMoment;
}();

var DeltaHistoryManager = /*#__PURE__*/function () {
  function DeltaHistoryManager() {
    _classCallCheck(this, DeltaHistoryManager);

    this._moments = [], this._currentPosition = -1;
  }

  _createClass(DeltaHistoryManager, [{
    key: "checkpoint",
    value: function checkpoint(t, s) {
      var r = this._parseMomentFromArguments(t, s);

      this._pushMoment(r);
    }
  }, {
    key: "push",
    value: function push(t, s) {
      var r = this._parseMomentFromArguments(t, s);

      this._pushMoment(r), r.forward();
    }
  }, {
    key: "forward",
    value: function forward() {
      ++this._currentPosition, this._moments[this._currentPosition].forward();
    }
  }, {
    key: "reverse",
    value: function reverse() {
      this._moments[this._currentPosition].reverse(), --this._currentPosition;
    }
  }, {
    key: "canForward",
    value: function canForward() {
      return this._currentPosition < this._moments.length - 1;
    }
  }, {
    key: "canReverse",
    value: function canReverse() {
      return this._currentPosition >= 0;
    }
  }, {
    key: "_parseMomentFromArguments",
    value: function _parseMomentFromArguments(t, s) {
      return new HistoryMoment(t, s);
    }
  }, {
    key: "_pushMoment",
    value: function _pushMoment(t) {
      this._currentPosition !== this._moments.length - 1 && (this._moments = this._moments.slice(0, this._currentPosition + 1)), this._moments.push(t), ++this._currentPosition;
    }
  }]);

  return DeltaHistoryManager;
}();

export { DeltaHistoryManager as D, HistoryMoment as H };